import React from 'react'
import { Field } from '@codegateinc/react-form-builder-v2'
import { FormComponents } from 'lib/components'
import { DropdownProps } from 'lib/types'

export const Dropdown = <ValueType,>(dropdownProps: DropdownProps<ValueType> & Field<ValueType>) => (
    <FormComponents.Dropdown {...dropdownProps}/>
)
